import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TooltipModule} from 'ng2-bootstrap/tooltip';

import {TypeSerialComponent} from './type-serial.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TooltipModule.forRoot(),
  ],
  declarations: [
    TypeSerialComponent,
  ],
  exports: [
    TypeSerialComponent,
  ],
})
export class TypeSerialModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/badges/badges-details/type-components/type-serial/type-serial.module.ts